<template>
  <div class="info-container">
    <div class="info-row">
      <div class="info-label">名称：</div>
      <div class="info-value">{{ info.name }}</div>
    </div>
    <div class="info-row">
      <div class="info-label">地址：</div>
      <div class="info-value">{{ info.address }}</div>
    </div>
    <div class="info-row">
      <div class="info-label">联系电话：</div>
      <div class="info-value">{{ info.phone }}</div>
    </div>
    <!-- <div>经营范围：{{info.businessRange}}</div> -->
    <!-- <div><el-button class="custom-button" @click="handleClick(info)">在线沟通</el-button></div> -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { SendMessage, companyByid } from "@/api/websocket.js";
export default {
  props: ["info"],
  methods: {
    /**
     * 在线沟通
     */
    async handleClick(info) {},
  },
};
</script>
<style lang="less" scoped>
@import "~@/styles/JStyle";
.info-container .info-row .info-label {
  width: 70px; 
}
.custom-button {
  color: #3418c4;
}
</style>

